export default __webpack_public_path__ + "static/media/lung2.071c0fc3.jpg";